
export class NavigationListResponseModel {
    
    public redirect:any;
    public name:string;
    public isCategory:number;
    public categoryId:number;
    public id:number;
    public child:any;
  
    constructor(navigationListResponse: any) {
      this.redirect=navigationListResponse.redirect||'',
      this.name=navigationListResponse.name||'',
      this.isCategory=navigationListResponse.isCategory||0,
      this.categoryId=navigationListResponse.categoryId||0,
      this.id=navigationListResponse.id||null
      this.child=navigationListResponse.child||[]
    }
  }
  